import manifest from "./generated/tokens-manifest.json";

/* Base colours only. --radius-12 and --spacing-16 are the same shape but are
   lengths, and a length in a <color> slot resolves to nothing. */
const STEP_NAME = /^--[a-z]+-\d{2,3}$/;

function loadPaletteSteps(): ReadonlyMap<string, string> {
  if (process.env.NODE_ENV === "production") {
    return new Map();
  }

  return new Map(
    manifest.colors
      .filter(colour => colour.tier === "base" && STEP_NAME.test(colour.name))
      .map(colour => [colour.name, colour.resolved.toLowerCase()] as [string, string])
  );
}

export const PALETTE_STEPS: ReadonlyMap<string, string> = loadPaletteSteps();
